// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__JySpC","form":"styles_form__1tfxP"};